<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card height="100%">
        <v-form ref="form" class="scroll-form" v-model="valid" lazy-validation>
          <v-card-title
            class="headline indigo darken-4 white--text fixed-header"
            primary-title
          >
            {{ $vuetify.t('$vuetify.calls.preWorkAnalysis').toUpperCase() }}
          </v-card-title>

          <v-card-text>
            <v-text-field
              mask="time"
              v-model="estimatedTime"
              :label="
                $vuetify.t(
                  '$vuetify.preWorkAnalysis.estimatedTimeToCompleteVisit'
                )
              "
              :rules="[rules.required, rules.gtzero]"
              required
            >
            </v-text-field>

            <v-text-field
              :label="
                $vuetify.t('$vuetify.preWorkAnalysis.estimatedCostOfMaterials')
              "
              v-model="estimatedCost"
              :rules="[rules.required]"
              prefix="£"
              type="number"
              required
            ></v-text-field>

            <media-dialog stage="start"></media-dialog>
          </v-card-text>

          <div class="footer text-xs-center mb-3">
            <v-divider></v-divider>
            <v-card-text>
              <v-btn @click="back()">
                {{ $vuetify.t('$vuetify.calls.back') }}
              </v-btn>

              <v-btn color="success" @click="confirmPreWorkAnalysis()">
                {{ $vuetify.t('$vuetify.preWorkAnalysis.beginWorkOnJob') }}
              </v-btn>
              <abort-visit v-on:aborted="visitAborted()" />
            </v-card-text>
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmArrivalDialog" fullscreen persistent>
      <v-card>
        <v-card-title
          class="headline indigo darken-4 white--text"
          primary-title
        >
          {{
            $vuetify
              .t('$vuetify.preWorkAnalysis.arrivalConfirmation')
              .toUpperCase()
          }}
        </v-card-title>
        <v-card-text>
          {{ $vuetify.t('$vuetify.preWorkAnalysis.startedWorkAt') }}
          {{ now() }}.
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn @click=";(confirmArrivalDialog = false), (dialog = true)">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>
            <v-btn color="success" @click="confirmArrivalDialog = false">{{
              $vuetify.t('$vuetify.app.ok')
            }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import PreWorkAnalysisMediaList from './PreWorkAnalysisMediaList.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AbortVisit from '@/components/AbortVisit.vue'
import MediaDialog from '@/components/media/MediaDialog.vue'

export default {
  props: ['show', 'notes', 'duration'],

  components: {
    PreWorkAnalysisMediaList,
    AbortVisit,
    MediaDialog
  },

  data() {
    return {
      dialog: false,
      valid: false,
      estimatedTime: '0000',
      confirmArrivalDialog: false,
      datetime: '',
      estimatedCost: null,
      rules: {
        required: value => !!value || 'This field is required',
        gtzero: value => value > 0 || 'Must be more than 00:00'
      },
      mediaDialog: false,
      cameraDialog: false,
      savedMedia: null
    }
  },

  mounted() {
    this.readCalls()

    if (this.duration) {
      var hours =
        Math.floor(this.duration / 60) < 10
          ? '0' + Math.floor(this.duration / 60)
          : Math.floor(this.duration / 60)
      var minutes =
        this.duration % 60 < 10
          ? '0' + (this.duration % 60)
          : this.duration % 60
      this.estimatedTime = '' + hours + minutes
    }
  },

  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      callMedia: 'calls/getMedia',
      callDetail: 'calls/getActiveCall'
    })
  },

  methods: {
    ...mapActions({
      readCalls: 'calls/readCalls',
      addMedia: 'calls/addMedia'
    }),

    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    confirmPreWorkAnalysis() {
      if (
        this.$refs.form.validate() &&
        this.callDetail.media &&
        this.callDetail.media.length > 0
      ) {
        this.dialog = false
        this.confirmArrivalDialog = true
        var duration = 0
        var hours = this.estimatedTime.slice(0, 2) * 1
        var minutes = this.estimatedTime.slice(2) * 1

        duration = hours * 60 + minutes

        this.$emit('confirmed', {
          estimated_time_minutes: duration,
          estimated_cost_gbp: this.estimatedCost ? this.estimatedCost : 0
        })
      }
    },

    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },

    back() {
      this.dialog = false
      this.$emit('back')
    },

    now() {
      return moment().format('DD/MM/YYYY HH:mm')
    }
  },

  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    }
  }
}
</script>

<style scoped>
.captureButton {
  cursor: pointer;
}

.uploadButton {
  cursor: pointer;
}

video {
  max-width: 100%;
  max-height: 46vh;
}

.flash {
  border: 10px solid rgba(255, 255, 255, 0.8);
}

.btn-file {
  position: relative;
  overflow: hidden;
}

.btn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  opacity: 0;
  outline: none;
  background: #fff;
  cursor: inherit;
  display: block;
}
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
